var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2274_9964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.85 -0.275002C238.875 -0.275002 100 139.4 100 304.825C100 478.075 260.975 655.25 369.25 779.775C369.675 780.275 387.175 799.7 408.725 799.7H410.625C432.2 799.7 449.575 780.275 450 779.775C551.6 662.975 700 470.35 700 304.825C700 139.375 591.675 -0.275002 402.85 -0.275002ZM412.875 746.225C412 747.1 410.725 748.075 409.6 748.9C408.45 748.1 407.2 747.1 406.275 746.225L393.2 731.175C290.55 613.425 149.975 452.15 149.975 304.8C149.975 166.5 265.775 49.675 402.825 49.675C573.55 49.675 649.975 177.8 649.975 304.8C649.975 416.65 570.2 565.2 412.875 746.225ZM400.875 151.1C318.05 151.1 250.875 218.25 250.875 301.1C250.875 383.95 318.05 451.1 400.875 451.1C483.7 451.1 550.875 383.925 550.875 301.1C550.875 218.275 483.725 151.1 400.875 151.1ZM400.875 401.1C345.725 401.1 299.725 355.15 299.725 300C299.725 244.85 344.575 200 399.725 200C454.9 200 499.725 244.85 499.725 300C499.75 355.15 456.05 401.1 400.875 401.1Z",
    fill: "#EAA827"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2274_9964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.ba465519db99f19d0fb037b66631ba45.svg";
export { ForwardRef as ReactComponent };